var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid slice",
    viewBox: "0 0 1490.35 1602.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-2,.cls-8{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px}.cls-1,.cls-3{clip-rule:evenodd}.cls-4{fill:#f7f7f7}.cls-10,.cls-5{opacity:.1}.cls-6{clip-path:url(#clip-path)}.cls-7{clip-path:url(#clip-path-2)}.cls-14,.cls-8{fill-rule:evenodd}.cls-9{clip-path:url(#clip-path-3)}.cls-11{clip-path:url(#clip-path-5)}.cls-12{clip-path:url(#clip-path-6)}.cls-13{clip-path:url(#clip-path-7)}.cls-15{clip-path:url(#clip-path-8)}.cls-16{isolation:isolate}.cls-17{clip-path:url(#clip-path-9)}.cls-18{clip-path:url(#clip-path-10)}.cls-19{clip-path:url(#clip-path-11)}.cls-20{opacity:.58}.cls-21{clip-path:url(#clip-path-12)}.cls-22{clip-path:url(#clip-path-13)}.cls-23{clip-path:url(#clip-path-14)}.cls-24{clip-path:url(#clip-path-15)}.cls-25{clip-path:url(#clip-path-16)}.cls-26{clip-path:url(#clip-path-17)}.cls-27{clip-path:url(#clip-path-18)}.cls-28{clip-path:url(#clip-path-19)}.cls-29{clip-path:url(#clip-path-20)}.cls-30{clip-path:url(#clip-path-21)}.cls-31{clip-path:url(#clip-path-22)}.cls-32{clip-path:url(#clip-path-23)}.cls-33{clip-path:url(#clip-path-24)}.cls-34{clip-path:url(#clip-path-25)}.cls-35{clip-path:url(#clip-path-26)}.cls-36{clip-path:url(#clip-path-27)}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1334.91 1484.41a9.3 9.3 0 0 1 11.19-5c4.34 1.33 6.85 6 6.38 10.34z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(-72.87 1377.342 1489.368)",
    d: "M1288.12 1400.16h178.41v178.41h-178.41z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1379 1498a9.3 9.3 0 0 1 11.19-5c4.33 1.34 6.85 6 6.38 10.34z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M382.36 1372.73l6.47 17.48a6.87 6.87 0 0 1-4.06 8.83l-16.87 6.24a6.87 6.87 0 0 1-8.83-4.06l-6.46-17.48"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.33 596.58l-43.65-23.75-2.27 12.06 37.22 20.25 8.7-8.56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.13 633.57a31.7 31.7 0 0 0 1.36 10.67 17.85 17.85 0 0 0 8.67 10.49l18 9.69a18 18 0 0 0 16.09.52 33.52 33.52 0 0 0 6.2-3.72z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1218.21 601.55l-14.21-6.61a11.44 11.44 0 0 0 5.14-.34 12.76 12.76 0 1 0-8.75-24c-2.06.75-4.05 2.69-5.84 5 .63-2.86.83-5.64.08-7.7a12.77 12.77 0 0 0-24 8.78 11.59 11.59 0 0 0 3.06 4.15l-17-7.9c-3.8-1.77-8.21-.37-9.83 3.12l-2.34 5a3.13 3.13 0 0 0 1.51 4.14l.89.42-12.25 26.39a7 7 0 0 0 3.38 9.26l55.27 25.67a7 7 0 0 0 9.26-3.39l12.23-26.34.9.41a3.12 3.12 0 0 0 4.13-1.52l2.33-5c1.62-3.5-.17-7.78-3.96-9.54zm-17-28.51a10.21 10.21 0 0 1 13.07 6.08 10.17 10.17 0 0 1-6.07 13.06c-4.07 1.48-13.41-2.27-17.75-4.36 2.05-4.45 6.72-13.29 10.79-14.82zm-27.86-5a10.19 10.19 0 0 1 18.81.8c1.49 4.07-2.25 13.34-4.36 17.74-4.4-2-13.29-6.68-14.78-10.75a10.17 10.17 0 0 1 .37-7.83zm-26.54 14.16l2.33-5c1-2.19 3.89-3 6.41-1.85l28.8 13.37-4.4 9.48-32.88-15.27a.52.52 0 0 1-.22-.73zm-9.81 30.9l12.24-26.35 29.65 13.77-14.09 30.33-25.67-11.93a4.39 4.39 0 0 1-2.13-5.82zm63.23 29.37a4.39 4.39 0 0 1-5.83 2.12l-27.26-12.66 14.08-30.32 31.25 14.51zm17.28-27.47a.53.53 0 0 1-.71.25l-34.48-16 4.41-9.48 30.39 14.12c2.52 1.17 3.74 3.9 2.72 6.09zm-63.93-.58a1.29 1.29 0 0 1-.67-.72l-3.5-9.59a1.31 1.31 0 0 1 0-1 1.33 1.33 0 0 1 .73-.67l9.59-3.5a1.26 1.26 0 0 1 1.64.76l3.51 9.59a1.31 1.31 0 0 1 0 1 1.33 1.33 0 0 1-.73.67l-9.59 3.51a1.28 1.28 0 0 1-.98-.03zm-1.31-10l2.62 7.16 7.17-2.61-2.62-7.17zm1.8-36.82a1.27 1.27 0 0 1-.67-.73l-3.5-9.59a1.26 1.26 0 0 1 0-1 1.3 1.3 0 0 1 .73-.67l9.59-3.51a1.28 1.28 0 0 1 1.64.77l3.51 9.59a1.31 1.31 0 0 1-.77 1.66l-9.59 3.5a1.27 1.27 0 0 1-.94.01zm-1.31-10l2.62 7.17 7.16-2.62-2.61-7.17z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-65.09 1181.96 599.85)",
    d: "M1134.59 552.39h94.91v94.91h-94.91z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1156.34 542.53a6.31 6.31 0 0 1 8.37-3.06l74.65 34.67a6.31 6.31 0 0 1 3.06 8.37l-34.67 74.65a6.33 6.33 0 0 1-8.37 3.06l-74.65-34.68a6.31 6.31 0 0 1-3.06-8.36z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-65.09 1179.755 597.086)",
    d: "M1140.3 552.78h79.09v88.58h-79.09z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M450.05 123c.13-1-.16-3-3.6-4.89L418 102.67l2.66-31.28c.33-3.79-1.23-5.14-2.19-5.61a1.78 1.78 0 0 0-2.39.75 1.71 1.71 0 0 0 .82 2.3 3.66 3.66 0 0 1 .24 2.18l-2.76 32.43a1.76 1.76 0 0 0 .93 1.7l29.46 16a7.16 7.16 0 0 1 1.76 1.26 3.63 3.63 0 0 1-2 .84l-32.41 6.64a1.75 1.75 0 0 0-.63.26c-.09.07-.15.16-.23.23a1.73 1.73 0 0 0-.23.24 1.49 1.49 0 0 0-.23.57v.05l-5.65 32a7.87 7.87 0 0 1-.63 2c-.15-.05-.75-.41-1.51-1.66l-17.26-28.33a1.85 1.85 0 0 0-1.77-.86L351 138.16a7.82 7.82 0 0 1-2.15 0c0-.14.14-.81 1.11-1.87l21.73-24.14a1.67 1.67 0 0 0 .25-1.89L357.23 80.6a8.17 8.17 0 0 1-.69-2 3.79 3.79 0 0 1 2.18.5l30.71 13.4a1.76 1.76 0 0 0 1.91-.3l17.58-16.31a1.71 1.71 0 0 0 0-2.45 1.8 1.8 0 0 0-2.5-.1l-16.7 15.52-29.63-12.93c-3.58-1.57-5.34-.57-6.06.17s-1.69 2.49 0 6l14.2 28.59-21 23.29c-2.54 2.82-2.06 4.79-1.55 5.71s1.94 2.4 5.78 2l31.8-3.69L400 165.24a7.47 7.47 0 0 0 3 3 3.55 3.55 0 0 0 2.14.36c1-.17 2.88-1 3.55-4.74l5.38-30.86 31.27-6.41c3.79-.77 4.57-2.61 4.71-3.63"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-63.99 396.821 110.228)",
    d: "M334.99 48.41h123.65v123.65H334.99z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.76 34.93a8.23 8.23 0 0 1 11-3.77l96.37 47a8.23 8.23 0 0 1 3.78 11l-47 96.37a8.22 8.22 0 0 1-11 3.78l-96.37-47a8.24 8.24 0 0 1-3.78-11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-63.99 395.92 112.08)",
    d: "M344.39 54.38h103.04v115.4H344.39z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.23 355.57a14.42 14.42 0 1 0 8.19-18.75 14.5 14.5 0 0 0-8.19 18.75zm24.23-9.4a11.57 11.57 0 1 1-15-6.68 11.63 11.63 0 0 1 15 6.68zm9.11-34.86l-2.8-4.13c-.84-1.22-3.79-4.49-6.4-3.48l-50.93 19.77c-2.61 1-2.59 5.42-2.38 6.89l.72 4.94a1.42 1.42 0 0 0 .7 1 1.4 1.4 0 0 0 1.23.1l3.73-1.4v.11L107 393.32a6 6 0 0 0 7.57 3.1l32.19-12.5a6 6 0 0 0 3.51-7.37l-16.44-54.85a1.42 1.42 0 1 0-2.73.81l16.41 54.88a3.12 3.12 0 0 1-1.82 3.86l-32.19 12.49a3.1 3.1 0 0 1-4-1.63L82.09 334l52.82-20.51a1.42 1.42 0 0 0 .85-.91 1.49 1.49 0 0 0-.19-1.27zm-59.22 21.8l-.46-3.11c-.24-1.63.2-3.57.59-3.81l50.92-19.77c.46-.08 2.09 1.05 3 2.41l1.79 2.63z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-21.22 114.257 352.416)",
    d: "M66.9 305.06h94.79v94.79H66.9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.24 331.29a6.31 6.31 0 0 1 3.59-8.15l76.63-29.75a6.31 6.31 0 0 1 8.14 3.61l29.75 76.63a6.31 6.31 0 0 1-3.58 8.15l-76.64 29.73a6.3 6.3 0 0 1-8.13-3.59z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-21.22 116.329 353.301)",
    d: "M80.01 310.7h72.67v85.31H80.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.62 903.2l-20.17 14.18a1.54 1.54 0 0 0-.34 2.14l30.43 43.26-37.17 26.15a5.24 5.24 0 0 1-7.27-1.35l-23.45-33.34a5.24 5.24 0 0 1 1.17-7.3l28.06-19.74a1.55 1.55 0 0 0-1.78-2.53L379 944.41a8.29 8.29 0 0 0-1.82 11.59l23.45 33.34a8.29 8.29 0 0 0 11.52 2.14l58.58-41.21a8.29 8.29 0 0 0 1.87-11.56l-23.46-33.34a8.3 8.3 0 0 0-11.52-2.17zm32.51 37.22a5.25 5.25 0 0 1-1.18 7.3L450 961l-29.54-42 18.94-13.32a5.22 5.22 0 0 1 7.26 1.36zm-35.08-25.75a11.07 11.07 0 1 0 15.54 2.6 11.16 11.16 0 0 0-15.54-2.6zm11 15.67a8.09 8.09 0 1 1 2.07-11.34 8.14 8.14 0 0 1-2.05 11.34zm-19.83 18.91a1.49 1.49 0 1 1 1.71 2.44l-25.87 18.21a1.49 1.49 0 1 1-1.71-2.44zm-9.18 15.83a1.49 1.49 0 1 1 1.71 2.45l-12.29 8.65a1.49 1.49 0 1 1-1.72-2.44z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-35.13 421.881 943.091)",
    d: "M371.2 892.41h101.53v101.53H371.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M355.11 936.38a6.75 6.75 0 0 1 1.64-9.39l72-50.66a6.75 6.75 0 0 1 9.39 1.63l50.66 72a6.74 6.74 0 0 1-1.63 9.39l-72 50.66a6.75 6.75 0 0 1-9.39-1.64z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-35.13 424.805 947.25)",
    d: "M380.89 918.56h87.99v57.53h-87.99z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98 1058.65a2.58 2.58 0 0 0 2.57-2.59v-4.72a2.6 2.6 0 0 0-2.68-2.58l-79.42 6.91a2.58 2.58 0 0 0-2.57 2.58v4.75a2.6 2.6 0 0 0 2.66 2.59l4.24-.3a1 1 0 0 0-.07.3v48.81a1.34 1.34 0 0 0 1.33 1.33h56.79a1.34 1.34 0 0 0 1.33-1.33v-54.26zM53.32 1113v-31a1.75 1.75 0 0 1 1.73-1.75h14.58a1.75 1.75 0 0 1 1.73 1.75v31zm26.21 0H74v-31a4.4 4.4 0 0 0-4.38-4.42H55.05a4.41 4.41 0 0 0-4.38 4.42v31H25.39v-47.47a1.2 1.2 0 0 0-.1-.47l7.54-.54a1.33 1.33 0 0 0-.18-2.66l-14.1 1v-4.55l79.33-6.89v4.54l-57 5.28a1.34 1.34 0 0 0-1.2 1.46 1.31 1.31 0 0 0 1.45 1.2l38.41-3.56zM98 1067.71a12.63 12.63 0 1 0 12.55 12.63A12.61 12.61 0 0 0 98 1067.71zm0 22.59a10 10 0 1 1 9.9-10 9.94 9.94 0 0 1-9.9 10zm-68.37-7.88v8.44a3.7 3.7 0 0 0 3.69 3.7h8.88a3.7 3.7 0 0 0 3.69-3.7v-8.44a3.71 3.71 0 0 0-3.69-3.71h-8.89a3.7 3.7 0 0 0-3.69 3.71zm13.6 0v8.44a1 1 0 0 1-1 1h-8.92a1 1 0 0 1-1-1v-8.44a1 1 0 0 1 1-1h8.88a1 1 0 0 1 1.03 1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9 1029.68h95.4v95.4H15.9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.9 1036a6.34 6.34 0 0 1 6.33-6.33H105a6.34 6.34 0 0 1 6.33 6.33v82.74a6.34 6.34 0 0 1-6.33 6.33H22.23a6.34 6.34 0 0 1-6.33-6.33z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9 1048.76h95.4v69.96H15.9z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.74 9.64h1447.15v1562.94H15.74z",
    id: "bg"
  }), /*#__PURE__*/React.createElement("g", {
    id: "deco"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1216.5 1185.9a87.12 87.12 0 0 0-14.72 2.25m7.36 21.32a8.58 8.58 0 0 0 7.39 3.88 14.48 14.48 0 0 0-5.63-6.85 7.16 7.16 0 0 1 3.18.15 3.62 3.62 0 0 0 3.06-.55c.79-.72.62-2.38-.44-2.54 2.15.66 4.5 1.32 6.59.48s3.29-3.93 1.58-5.39m70.43-32.89a87.16 87.16 0 0 0 13.31-6.68m-14.44-14.08a35.51 35.51 0 0 0-5.58 7.17m-59.11-14.17a5.72 5.72 0 0 0-11.44 0 5.72 5.72 0 0 0 11.44 0zm84.85 68a5.73 5.73 0 0 0-11.45 0 5.73 5.73 0 1 0 11.45 0zm-33.83-26.75l2 5.28 18.33.8c2.39.1 2.8 1.39.94 2.87l-14.36 11.43m-12.88-33.97c.55 0 1.09.56 1.51 1.68l4.46 11.91m-11.72.25l2.55-7.64m-11.33 34.03l1.73-6.26-14.36-11.43c-1.86-1.48-1.45-2.77.94-2.87l3.56-.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1287.38 1199.63l4.9 17.68c.64 2.3-.46 3.1-2.45 1.78l-15.3-10.13-15.3 10.13c-2 1.32-3.09.52-2.45-1.78l3.17-11.42m-12.16-72.27c.55 0 1.1.56 1.52 1.68l6.42 17.19 18.34.8c2.38.1 2.8 1.39.93 2.88l-14.36 11.42M1260.64 1167.59l4.9 17.69c.64 2.29-.45 3.09-2.44 1.77l-15.31-10.12-15.3 10.12c-2 1.32-3.08.52-2.45-1.77l4.91-17.69-14.36-11.42c-1.87-1.49-1.45-2.78.93-2.88l18.33-.8 4.74-12.67"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(-72.87 1344.894 1483.257)",
    d: "M1338.46 1471.7h12.83v23.12h-12.83z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(-72.87 1377.342 1489.368)",
    d: "M1288.12 1400.16h178.41v178.41h-178.41z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1334.91 1484.41a9.3 9.3 0 0 1 11.19-5c4.34 1.33 6.85 6 6.38 10.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1334.91 1484.41a9.3 9.3 0 0 1 11.19-5c4.34 1.33 6.85 6 6.38 10.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1357.76 1491.45l5.89-15.24-30.79-9.49-3.64 15.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1366.81 1477.19l-37.11-11.44 1.78-3.45c.49-.84 1.81-2.27 2.73-2l31.93 9.84c.93.28 1.21 2.21 1.14 3.17z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(-72.87 1388.991 1496.849)",
    d: "M1382.55 1485.29h12.83v23.12h-12.83z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(-72.87 1377.342 1489.368)",
    d: "M1288.12 1400.16h178.41v178.41h-178.41z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1379 1498a9.3 9.3 0 0 1 11.19-5c4.33 1.34 6.85 6 6.38 10.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1379 1498a9.3 9.3 0 0 1 11.19-5c4.33 1.34 6.85 6 6.38 10.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1402.06 1504.53l5.69-14.72-30.79-9.49-3.71 15.91m37.66-5.45l-37.11-11.44 1.78-3.45c.49-.84 1.81-2.27 2.73-2l31.93 9.84c.93.28 1.21 2.21 1.14 3.17zm-55.46-27.3l4.9-15.87a6.17 6.17 0 0 1 7.7-4.08l46.12 14.22a6.15 6.15 0 0 1 4.07 7.7l-4.77 15.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1400.45 1473.69l-30-9.26a5.51 5.51 0 1 1 3.25-10.52l30 9.26a5.5 5.5 0 1 1-3.24 10.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(-72.87 1359.834 1512.305)",
    d: "M1345.96 1467.76h27.72v89.08h-27.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1408.47 1498.7a9.17 9.17 0 0 1 1.12.28 9.3 9.3 0 0 1 6.51 9.88m5.34 1.65l3.98-10.78m-10.63-14.58l14.84 4.57c.92.29 1.21 2.21 1.14 3.18l-.47 3.85-15.81-4.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(-72.87 1412.094 1528.406)",
    d: "M1398.21 1518.26h27.72v20.28h-27.72z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M352.1 1382.35l29.75-11m-6.34-17.14l13.32 36a6.87 6.87 0 0 1-4.06 8.83l-16.87 6.24a6.86 6.86 0 0 1-8.82-4.06l-13.32-36 24.89-9.21m2.58 59.93l-1.03-2.78m14.43-5.34l1.03 2.79m36.37 37.98l-48.97 18.11m20.36-66.95l9.27-3.43 17.35 46.88m-37.69 8.55a19.54 19.54 0 1 1 21.52-26c2.37 6.38 1.88 13.43-1.82 18.65a8.17 8.17 0 0 1-4 3l-11.66 4.08a8.2 8.2 0 0 1-4.04.27zm-16.52-41.8l20.04-7.41"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(-20.3 381.45 1408.625)",
    d: "M271.37 1298.58h220.17v220.17H271.37z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M382.36 1372.73l6.47 17.48a6.87 6.87 0 0 1-4.06 8.83l-16.87 6.24a6.87 6.87 0 0 1-8.83-4.06l-6.46-17.48"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(-61.44 341.313 614.037)",
    d: "M234 506.74h214.55v214.55H234z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M384.33 596.58l-43.65-23.75-2.27 12.06 37.22 20.25 8.7-8.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M384.33 596.58l-43.65-23.75-2.27 12.06 37.22 20.25 8.7-8.56z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(-61.44 341.313 614.037)",
    d: "M234 506.74h214.55v214.55H234z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M303.13 633.57a31.7 31.7 0 0 0 1.36 10.67 17.85 17.85 0 0 0 8.67 10.49l18 9.69a18 18 0 0 0 16.09.52 33.52 33.52 0 0 0 6.2-3.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.13 633.57a31.7 31.7 0 0 0 1.36 10.67 17.85 17.85 0 0 0 8.67 10.49l18 9.69a18 18 0 0 0 16.09.52 33.52 33.52 0 0 0 6.2-3.72zm39.16-69.31l-3.88 20.63m37.22 20.25l15.78-14.15m-80.75 54.53a13.09 13.09 0 0 0 4.89 4.65M312.18 621a26.78 26.78 0 0 0-3.52 18.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366.35 641a31.93 31.93 0 0 1-3.35 9.2 34.79 34.79 0 0 1-15.78 14.74 18 18 0 0 1-16.09-.52l-18-9.69a17.85 17.85 0 0 1-8.67-10.49 31.81 31.81 0 0 1 3.29-25.93m4.82-6.8l15.25-12.05 1.83-19.34 54.31 29.56-15.25 12.04-1.83 19.34-54.31-29.55m78.84-20.52l4.19-3.75-52.29-28.46-1.02 5.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326.19 595.42a2.85 2.85 0 1 0-.77 5.28A1.87 1.87 0 0 0 327 599a2.61 2.61 0 0 0-.51-1.2 30.68 30.68 0 0 0-15.7-12.12M307.41 600a48.59 48.59 0 0 1 16.87.92c16 3.72 28.93 15.56 43.43 23.33m25.66-32.19l-57.16-31.11-2.59 19.05m47.14 27.94l16.88-13.56"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1218.21 601.55l-14.21-6.61a11.44 11.44 0 0 0 5.14-.34 12.76 12.76 0 1 0-8.75-24c-2.06.75-4.05 2.69-5.84 5 .63-2.86.83-5.64.08-7.7a12.77 12.77 0 0 0-24 8.78 11.59 11.59 0 0 0 3.06 4.15l-17-7.9c-3.8-1.77-8.21-.37-9.83 3.12l-2.34 5a3.13 3.13 0 0 0 1.51 4.14l.89.42-12.25 26.39a7 7 0 0 0 3.38 9.26l55.27 25.67a7 7 0 0 0 9.26-3.39l12.23-26.34.9.41a3.12 3.12 0 0 0 4.13-1.52l2.33-5c1.62-3.5-.17-7.78-3.96-9.54zm-17-28.51a10.21 10.21 0 0 1 13.07 6.08 10.17 10.17 0 0 1-6.07 13.06c-4.07 1.48-13.41-2.27-17.75-4.36 2.05-4.45 6.72-13.29 10.79-14.82zm-27.86-5a10.19 10.19 0 0 1 18.81.8c1.49 4.07-2.25 13.34-4.36 17.74-4.4-2-13.29-6.68-14.78-10.75a10.17 10.17 0 0 1 .37-7.83zm-26.54 14.16l2.33-5c1-2.19 3.89-3 6.41-1.85l28.8 13.37-4.4 9.48-32.88-15.27a.52.52 0 0 1-.22-.73zm-9.81 30.9l12.24-26.35 29.65 13.77-14.09 30.33-25.67-11.93a4.39 4.39 0 0 1-2.13-5.82zm63.23 29.37a4.39 4.39 0 0 1-5.83 2.12l-27.26-12.66 14.08-30.32 31.25 14.51zm17.28-27.47a.53.53 0 0 1-.71.25l-34.48-16 4.41-9.48 30.39 14.12c2.52 1.17 3.74 3.9 2.72 6.09zm-63.93-.58a1.29 1.29 0 0 1-.67-.72l-3.5-9.59a1.31 1.31 0 0 1 0-1 1.33 1.33 0 0 1 .73-.67l9.59-3.5a1.26 1.26 0 0 1 1.64.76l3.51 9.59a1.31 1.31 0 0 1 0 1 1.33 1.33 0 0 1-.73.67l-9.59 3.51a1.28 1.28 0 0 1-.98-.03zm-1.31-10l2.62 7.16 7.17-2.61-2.62-7.17zm1.8-36.82a1.27 1.27 0 0 1-.67-.73l-3.5-9.59a1.26 1.26 0 0 1 0-1 1.3 1.3 0 0 1 .73-.67l9.59-3.51a1.28 1.28 0 0 1 1.64.77l3.51 9.59a1.31 1.31 0 0 1-.77 1.66l-9.59 3.5a1.27 1.27 0 0 1-.94.01zm-1.31-10l2.62 7.17 7.16-2.62-2.61-7.17z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-65.09 1181.96 599.85)",
    d: "M1134.59 552.39h94.91v94.91h-94.91z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1156.34 542.53a6.31 6.31 0 0 1 8.37-3.06l74.65 34.67a6.31 6.31 0 0 1 3.06 8.37l-34.67 74.65a6.33 6.33 0 0 1-8.37 3.06l-74.65-34.68a6.31 6.31 0 0 1-3.06-8.36z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-65.09 1179.755 597.086)",
    d: "M1140.3 552.78h79.09v88.58h-79.09z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    transform: "rotate(-65.09 1181.96 599.85)",
    d: "M1118.77 536.57h126.54v126.54h-126.54z"
  }))))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1417.67 815.55l-34.12-14.2-30.64 47.57a4.79 4.79 0 0 0 2.35 6.74l48.09 20a4.77 4.77 0 0 0 6.43-3.08l12.15-55.26m-36.39-19.88l36.82 15.32m-17.06-17.32l4.55 1.9a3.61 3.61 0 0 1 1.4 5.65l-11-4.56a3.63 3.63 0 0 1 5.05-2.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1419.57 828a10.2 10.2 0 0 1 5.5 13.34l-.65 1.57a10.19 10.19 0 0 1-5.53 5.51l-3.62 1.5m-63.27 1.22l-1.59-.67c-4.2-1.75-6.72-4.13-7.72-7.3-1.92-6.1 2.59-13.17 7.36-20.65 4.59-7.19 9.33-14.63 7.57-20.21-1-3.15-3.41-5.32-8.12-7.28l-.62-.26.46-.56a3.3 3.3 0 0 0 .64-2.84l-.24-1 .92.38c6.13 2.55 9.77 5.89 11.12 10.21 2.37 7.52-2.93 15.83-8 23.86-4 6.31-8.19 12.84-6.88 17a7 7 0 0 0 3.7 3.85m17.09-8.63l-5.18 8.38m22.95-37.12l-12.36 19.99m-19.74-19.41a15.23 15.23 0 1 1-2.1-29.77m47.21-8.03a6.93 6.93 0 1 0-9.06 3.73 6.94 6.94 0 0 0 9.06-3.73zm-5.59-15.69a4.34 4.34 0 1 0-5.68 2.34 4.35 4.35 0 0 0 5.68-2.34zm-29.61 2.16a6.93 6.93 0 0 0-3.84 11.7m16.8 37.25a13 13 0 0 1-10 0 12.86 12.86 0 0 1-3.12-1.83m7.14-23.34a13.09 13.09 0 0 1 6 1 12.93 12.93 0 0 1 5.84 4.79m-29.74-3.32a14.94 14.94 0 0 1 5.25-17.94m14.97-.02a15 15 0 0 1 6.7 16.74m.82 10.24a9.68 9.68 0 0 1 .66-2.52 9.39 9.39 0 0 1 12.28-5.06 9.14 9.14 0 0 1 5.6 7.75m-39.03-8.69a5.13 5.13 0 0 1 .41-2.09 5.31 5.31 0 1 1 3.84 7.24"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M450.05 123c.13-1-.16-3-3.6-4.89L418 102.67l2.66-31.28c.33-3.79-1.23-5.14-2.19-5.61a1.78 1.78 0 0 0-2.39.75 1.71 1.71 0 0 0 .82 2.3 3.66 3.66 0 0 1 .24 2.18l-2.76 32.43a1.76 1.76 0 0 0 .93 1.7l29.46 16a7.16 7.16 0 0 1 1.76 1.26 3.63 3.63 0 0 1-2 .84l-32.41 6.64a1.75 1.75 0 0 0-.63.26c-.09.07-.15.16-.23.23a1.73 1.73 0 0 0-.23.24 1.49 1.49 0 0 0-.23.57v.05l-5.65 32a7.87 7.87 0 0 1-.63 2c-.15-.05-.75-.41-1.51-1.66l-17.26-28.33a1.85 1.85 0 0 0-1.77-.86L351 138.16a7.82 7.82 0 0 1-2.15 0c0-.14.14-.81 1.11-1.87l21.73-24.14a1.67 1.67 0 0 0 .25-1.89L357.23 80.6a8.17 8.17 0 0 1-.69-2 3.79 3.79 0 0 1 2.18.5l30.71 13.4a1.76 1.76 0 0 0 1.91-.3l17.58-16.31a1.71 1.71 0 0 0 0-2.45 1.8 1.8 0 0 0-2.5-.1l-16.7 15.52-29.63-12.93c-3.58-1.57-5.34-.57-6.06.17s-1.69 2.49 0 6l14.2 28.59-21 23.29c-2.54 2.82-2.06 4.79-1.55 5.71s1.94 2.4 5.78 2l31.8-3.69L400 165.24a7.47 7.47 0 0 0 3 3 3.55 3.55 0 0 0 2.14.36c1-.17 2.88-1 3.55-4.74l5.38-30.86 31.27-6.41c3.79-.77 4.57-2.61 4.71-3.63"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-63.99 396.821 110.228)",
    d: "M334.99 48.41h123.65v123.65H334.99z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M364.76 34.93a8.23 8.23 0 0 1 11-3.77l96.37 47a8.23 8.23 0 0 1 3.78 11l-47 96.37a8.22 8.22 0 0 1-11 3.78l-96.37-47a8.24 8.24 0 0 1-3.78-11z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-63.99 395.92 112.08)",
    d: "M344.39 54.38h103.04v115.4H344.39z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    transform: "rotate(-63.99 396.821 110.228)",
    d: "M314.38 27.8h164.86v164.86H314.38z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M102.23 355.57a14.42 14.42 0 1 0 8.19-18.75 14.5 14.5 0 0 0-8.19 18.75zm24.23-9.4a11.57 11.57 0 1 1-15-6.68 11.63 11.63 0 0 1 15 6.68zm9.11-34.86l-2.8-4.13c-.84-1.22-3.79-4.49-6.4-3.48l-50.93 19.77c-2.61 1-2.59 5.42-2.38 6.89l.72 4.94a1.42 1.42 0 0 0 .7 1 1.4 1.4 0 0 0 1.23.1l3.73-1.4v.11L107 393.32a6 6 0 0 0 7.57 3.1l32.19-12.5a6 6 0 0 0 3.51-7.37l-16.44-54.85a1.42 1.42 0 1 0-2.73.81l16.41 54.88a3.12 3.12 0 0 1-1.82 3.86l-32.19 12.49a3.1 3.1 0 0 1-4-1.63L82.09 334l52.82-20.51a1.42 1.42 0 0 0 .85-.91 1.49 1.49 0 0 0-.19-1.27zm-59.22 21.8l-.46-3.11c-.24-1.63.2-3.57.59-3.81l50.92-19.77c.46-.08 2.09 1.05 3 2.41l1.79 2.63z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-21.22 114.257 352.416)",
    d: "M66.9 305.06h94.79v94.79H66.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M55.24 331.29a6.31 6.31 0 0 1 3.59-8.15l76.63-29.75a6.31 6.31 0 0 1 8.14 3.61l29.75 76.63a6.31 6.31 0 0 1-3.58 8.15l-76.64 29.73a6.3 6.3 0 0 1-8.13-3.59z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-21.22 116.329 353.301)",
    d: "M80.01 310.7h72.67v85.31H80.01z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    transform: "rotate(-21.22 114.257 352.416)",
    d: "M51.1 289.26h126.39v126.39H51.1z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M437.62 903.2l-20.17 14.18a1.54 1.54 0 0 0-.34 2.14l30.43 43.26-37.17 26.15a5.24 5.24 0 0 1-7.27-1.35l-23.45-33.34a5.24 5.24 0 0 1 1.17-7.3l28.06-19.74a1.55 1.55 0 0 0-1.78-2.53L379 944.41a8.29 8.29 0 0 0-1.82 11.59l23.45 33.34a8.29 8.29 0 0 0 11.52 2.14l58.58-41.21a8.29 8.29 0 0 0 1.87-11.56l-23.46-33.34a8.3 8.3 0 0 0-11.52-2.17zm32.51 37.22a5.25 5.25 0 0 1-1.18 7.3L450 961l-29.54-42 18.94-13.32a5.22 5.22 0 0 1 7.26 1.36zm-35.08-25.75a11.07 11.07 0 1 0 15.54 2.6 11.16 11.16 0 0 0-15.54-2.6zm11 15.67a8.09 8.09 0 1 1 2.07-11.34 8.14 8.14 0 0 1-2.05 11.34zm-19.83 18.91a1.49 1.49 0 1 1 1.71 2.44l-25.87 18.21a1.49 1.49 0 1 1-1.71-2.44zm-9.18 15.83a1.49 1.49 0 1 1 1.71 2.45l-12.29 8.65a1.49 1.49 0 1 1-1.72-2.44z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-35.13 421.881 943.091)",
    d: "M371.2 892.41h101.53v101.53H371.2z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M355.11 936.38a6.75 6.75 0 0 1 1.64-9.39l72-50.66a6.75 6.75 0 0 1 9.39 1.63l50.66 72a6.74 6.74 0 0 1-1.63 9.39l-72 50.66a6.75 6.75 0 0 1-9.39-1.64z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-35.13 424.805 947.25)",
    d: "M380.89 918.56h87.99v57.53h-87.99z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    transform: "rotate(-35.13 421.881 943.091)",
    d: "M354.28 875.49h135.37v135.37H354.28z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M98 1058.65a2.58 2.58 0 0 0 2.57-2.59v-4.72a2.6 2.6 0 0 0-2.68-2.58l-79.42 6.91a2.58 2.58 0 0 0-2.57 2.58v4.75a2.6 2.6 0 0 0 2.66 2.59l4.24-.3a1 1 0 0 0-.07.3v48.81a1.34 1.34 0 0 0 1.33 1.33h56.79a1.34 1.34 0 0 0 1.33-1.33v-54.26zM53.32 1113v-31a1.75 1.75 0 0 1 1.73-1.75h14.58a1.75 1.75 0 0 1 1.73 1.75v31zm26.21 0H74v-31a4.4 4.4 0 0 0-4.38-4.42H55.05a4.41 4.41 0 0 0-4.38 4.42v31H25.39v-47.47a1.2 1.2 0 0 0-.1-.47l7.54-.54a1.33 1.33 0 0 0-.18-2.66l-14.1 1v-4.55l79.33-6.89v4.54l-57 5.28a1.34 1.34 0 0 0-1.2 1.46 1.31 1.31 0 0 0 1.45 1.2l38.41-3.56zM98 1067.71a12.63 12.63 0 1 0 12.55 12.63A12.61 12.61 0 0 0 98 1067.71zm0 22.59a10 10 0 1 1 9.9-10 9.94 9.94 0 0 1-9.9 10zm-68.37-7.88v8.44a3.7 3.7 0 0 0 3.69 3.7h8.88a3.7 3.7 0 0 0 3.69-3.7v-8.44a3.71 3.71 0 0 0-3.69-3.71h-8.89a3.7 3.7 0 0 0-3.69 3.71zm13.6 0v8.44a1 1 0 0 1-1 1h-8.92a1 1 0 0 1-1-1v-8.44a1 1 0 0 1 1-1h8.88a1 1 0 0 1 1.03 1z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9 1029.68h95.4v95.4H15.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M15.9 1036a6.34 6.34 0 0 1 6.33-6.33H105a6.34 6.34 0 0 1 6.33 6.33v82.74a6.34 6.34 0 0 1-6.33 6.33H22.23a6.34 6.34 0 0 1-6.33-6.33z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9 1048.76h95.4v69.96H15.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M0 1013.78h127.2v127.2H0z"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.f11208f78651ade6a162a675c9d9ea39.svg";
export { ForwardRef as ReactComponent };